import { IAppState } from '../../redux';

export function selectIsIdentificationNeeded(state: IAppState): boolean {
  const {
    publishAvailable: { isIdentificationNeeded },
  } = state;

  return isIdentificationNeeded;
}
